import { useContext } from "react";
import { FormContext } from "../formContext";
import { emptySetterFunction } from "@utils/helpers/emptyFunction";
import { useSetWithDismountFallback } from "@hooks/useSetWithDismountFallback";
import { useSelector } from "react-redux";

// note: if this hook doesnt finish firing (why wouldnt it??) we could have race condition issues
// with mounting pages. There must never be more than 1 consumer of this hook in the react virtual
// dom at any time
export const useSetOnSubmit = (onSubmit) => {
  const { button: {setOnSubmit} } = useContext(FormContext);
  useSetWithDismountFallback(setOnSubmit, emptySetterFunction, onSubmit)
};

export const useSetOnSubmitDefault = () => {
  const { isFetching } = useSelector(({loanForm}) => loanForm);
  
  const handleSubmit = () => {
    const shouldSubmit = !isFetching;
    return shouldSubmit
  };
  useSetOnSubmit(handleSubmit);
}